import React from 'react';
import LeaderboardView from '../../../common/components/gamification/LeaderboardView';

const InstructorLeaderboardPage = () => <LeaderboardView title="Leaderboard" />;

export default InstructorLeaderboardPage;
